import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, List, ListItem, Typography } from "@mui/material";


export interface howToPlayProps {
    open :boolean,
    handleClose: ()=>void
}

const HowToPlayDialog = ({open, handleClose}: howToPlayProps) =>  {
    
    return (<Dialog open={open} onClose={handleClose}>
        <DialogTitle>How to Play</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant={"body1"}>Prerequisites:
                <List>
                    <ListItem>You have a Steam Account</ListItem>
                    <ListItem>The Steam Account is set to public (see FAQ section)</ListItem>
                    <ListItem>You have the URL for the steam account</ListItem>
                </List>
                After you have submitted your steam URL, you will be faced with 2 games. 
                These are games in your library, and you have to guess which game you have played more hours of.
                Simply click the game you think you have played more of. You'll soon find out if your right.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Okay, I got it</Button>
        </DialogActions>
      </Dialog>
      )
  }
      
export default HowToPlayDialog